var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "conversation-cell",
      on: {
        mouseenter: function ($event) {
          _vm.showMenu = true
        },
        mouseleave: function ($event) {
          _vm.showMenu = false
        },
      },
    },
    [
      _vm.conversation
        ? _c(
            "div",
            {
              staticClass: "conversation-info",
              on: { click: _vm.viewConversation },
            },
            [
              _c(
                "div",
                { staticClass: "conversation-icon" },
                [_c("a-icon", { attrs: { type: "message" } })],
                1
              ),
              _vm._v(" "),
              _vm._m(0),
            ]
          )
        : _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _c("a", { on: { click: _vm.showConversationPicker } }, [
                _vm._v("+ Sohbet Ekle"),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.showMenu && _vm.conversation && !_vm.readonly
        ? _c(
            "div",
            { staticClass: "overlay-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("a-button", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    attrs: {
                      icon: "delete",
                      type: "danger",
                      size: "small",
                      content: "Sohbeti Kaldır",
                    },
                    on: { click: _vm.removeConversation },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Sohbet ID Girin",
                okText: "Kaydet",
                cancelText: "İptal",
              },
              on: { cancel: _vm.closeModal, ok: _vm.saveConversationId },
            },
            [
              _c(
                "div",
                { staticClass: "conversation-id-form" },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "Sohbet ID" } },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "Sohbet ID'sini girin" },
                        model: {
                          value: _vm.inputConversationId,
                          callback: function ($$v) {
                            _vm.inputConversationId = $$v
                          },
                          expression: "inputConversationId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-info" },
                    [
                      _c(
                        "a-alert",
                        { attrs: { type: "info", "show-icon": "" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "message" }, slot: "message" },
                            [
                              _vm._v(
                                "\n                        Sohbet ID'sini sohbet ekranından veya sohbet listesinden alabilirsiniz.\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "conversation-details" }, [
      _c("span", { staticClass: "conversation-name" }, [
        _vm._v("Sohbeti Görüntüle"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }